interface IHashtag {
  id: number;
  name: string;
  isSelected?: boolean;
}

class Hashtag {
  constructor(args: IHashtag) {
    return Object.assign(this, args);
  }
}

interface Hashtag extends IHashtag {
}

export default Hashtag;